import React, { useRef } from 'react'
import { KTSVG } from '../../../_metronic/helpers';
import useHandleCloseModal from '../../../hooks/HandleCloseModal';
import { useFormik } from 'formik';
import { useIntl } from 'react-intl';
import { Log } from '../../../interfaces/Log';
import { modules } from './utilityReactQuill';
import { formats } from './utilityReactQuill';
import ReactQuill from 'react-quill';
import clsx from 'clsx';
import { updateDescriptionLog, UpdateDescriptionLogProps } from '../../../api/LogsCRUD';
import useAccessToken from '../../../hooks/AccessToken';
import Swal from 'sweetalert2';
import { mutate } from 'swr';

interface EditDescModalProps {
    log: UpdateDescriptionLogProps | Log
    onClose: () => void
}

const API_URL = process.env.REACT_APP_API_URL;

const UpdateModalLog = ({ log, onClose }: EditDescModalProps) => {
    const modalRef = useRef<HTMLDivElement>(null);
    const closeModalRef = useRef<HTMLButtonElement>(null)
    const intl = useIntl()
    const token = useAccessToken()



    const formik = useFormik({
        initialValues: {
            description: log.description
        },
        onSubmit: async (values) => {
            try {
                const logData = log as any;

                const response = await updateDescriptionLog({
                    id: logData.id,
                    leadId: logData.lead_id,
                    description: values.description,
                    leadProgressId: logData.leadProgressId,
                    // subProgressId: logData.lead_sub_progress_id,
                    attachments: logData.attachments,
                    // leadProducts: logData.productLog,
                    token: token
                })

                if (response.data.success) {
                    onClose()
                    modalRef.current?.click()
                    mutate(`${API_URL}lead_logs/?lead_id=${logData.lead_id}`)
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Description updated successfully',
                        showConfirmButton: true,
                        timer: 1500
                    })
                }
            } catch (error) {
                console.log(error, 'error');
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Description update failed',
                })
            }

        }
    })

    const { handleCloseModal } = useHandleCloseModal(modalRef, closeModalRef, formik);


    return (
        <div className="modal fade" tabIndex={-1} id={`update-log-modal-${log.id}`} ref={modalRef}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{intl.formatMessage({ id: "FORM.ACTION.UPDATE" })} {(log as Log).lead_name}</h5>
                        <div
                            className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                            onClick={handleCloseModal}
                        >
                            <KTSVG
                                path="/media/icons/duotune/arrows/arr061.svg"
                                className="svg-icon svg-icon-2x"
                            />
                        </div>
                    </div>
                    <form onSubmit={formik.handleSubmit} noValidate>
                        <div className="modal-body">
                            <label className='form-label fs-6 fw-bolder text-dark required'>{intl.formatMessage({ id: "FORM.LABEL.DESCRIPTION" })}</label>
                            <div className="input-group mb-15">
                                <ReactQuill
                                    theme="snow"
                                    value={formik.values.description}
                                    onChange={(content) => {
                                        formik.setFieldValue('description', content)
                                    }}
                                    formats={formats}
                                    modules={modules}
                                    style={{ height: 170, width: '100%' }}
                                    onBlur={() => {
                                        formik.setFieldTouched('description', true)
                                    }}
                                    className={clsx('link',
                                        { 'is-invalid': formik.touched.description && formik.errors.description },
                                    )}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light d-none"
                                data-bs-dismiss="modal"
                                ref={closeModalRef}
                            >
                                {intl.formatMessage({ id: "FORM.ACTION.CANCEL" })}
                            </button>
                            <button
                                type="button"
                                className="btn btn-light"
                                onClick={handleCloseModal}
                            >
                                {intl.formatMessage({ id: "FORM.ACTION.CANCEL" })}
                            </button>
                            <button type="submit" className={`btn btn-primary me-10 ${formik.isSubmitting ? "disabled" : ""}`} data-kt-indicator={formik.isSubmitting ? 'on' : 'off'}>
                                <span className="indicator-label">
                                    {intl.formatMessage({ id: "FORM.ACTION.UPDATE" })}
                                </span>
                                <span className="indicator-progress">
                                    Loading... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default UpdateModalLog